import { LOCAL_STORAGE_STATE_PERSIST } from '@/utils/constants/checkin.constants';

const actions = {

  checkAdmissionIdsOnMedicalOrders({ commit }) {
    const savedData = localStorage.getItem(LOCAL_STORAGE_STATE_PERSIST);

    if (savedData) {
      const parsedData = JSON.parse(savedData);

      const admissionId = parsedData.currentAdmission.data.id;

      if (

        parsedData?.medicalOrders?.data?.uploadedMedicalOrders &&

        parsedData?.medicalOrders?.data.uploadedMedicalOrders.length

      ) {
        const allAdmissionIdMatchesWithinExams =

          parsedData?.medicalOrders?.data?.uploadedMedicalOrders.every(

            (item) => item.data.admissionId === admissionId

          );

        if (!allAdmissionIdMatchesWithinExams) {
          commit('SET_CLEAR_MEDICALORDERS');
        }

        return parsedData.medicalOrders;
      }
    }
  },

};

export default actions;
